import { useEffect, createContext, useReducer } from "react";
import Reducer from "./Reducer";

const INITIAL_STATE = {
    user: localStorage.getItem("user") || null,
};

export const AuthContext = createContext(INITIAL_STATE);

export const AuthProvider = ({ children }) => {

    const [state, dispatch] = useReducer(Reducer, INITIAL_STATE);

    useEffect(() => {
        state.user && localStorage.setItem("user", state.user);
    }, [state.user]);

    return (
        <AuthContext.Provider
            value={{
                user: state.user,
                dispatch,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};